import {GenericDao} from './generic.dao';
import {IAppConfig} from '../../store/interfaces/IAppConfig';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {LogService} from '../services/logging.service';
import {DataValidator} from './validators/data.validators';
import {RetryHandler} from './handlers/retry.handlers';
import {CookieService} from 'ngx-cookie-service';
import {resolveLocale} from '../../common/common';

const API_KEY_HEADER_NAME = 'X-IHG-API-KEY';
const SSO_TOKEN_ATTRIBUTE_NAME = 'X-IHG-SSO-TOKEN';
const LANGUAGE_HEADER_NAME = 'IHG-Language';

export abstract class ApigeeDAO extends GenericDao {
  protected cookieService: CookieService;
  constructor(name: string, http: HttpClient, appConfig: IAppConfig, daoConfig: any, retryHandler: RetryHandler, dataValidator: DataValidator, log: LogService, cookieService: CookieService) {
    super(name, http, appConfig, daoConfig, retryHandler, dataValidator, log);
    this.cookieService = cookieService;
  }
  protected buildHeaders(customHeaders?: {[key: string]: string}): HttpHeaders {
    let headers: HttpHeaders = super.buildHeaders(customHeaders);
    if (this.daoConfig.apiKey) {
      headers = headers.set(API_KEY_HEADER_NAME, String(this.daoConfig.apiKey));
    }
    const ssoToken = this.cookieService.get(SSO_TOKEN_ATTRIBUTE_NAME);
    if (ssoToken) {
      headers = headers.set(SSO_TOKEN_ATTRIBUTE_NAME, String(ssoToken));
    }
    headers = headers.set(LANGUAGE_HEADER_NAME, String(resolveLocale(this.appConfig)));
    return headers;
  }
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/api/daos/apigee.dao.ts